























































































import Vue from 'vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { ActionNames as PatientActionNames, GetterNames as PatientGetterNames } from '@/store/modules/patient/keys'
import { currentTimestamp } from '@/utils/time'
import { toReadableTimeFromTimestamp } from '@/components/exercises/measure/filters'
import { isInAnyRoom, isInOwnRoom, hasUnaddressedLiveAlert } from '@/utils/patients'
import { PATIENT_NOUN } from '@/constants/app-variables'
import LouisBrierMainFloor from '@/components/map/static-maps/louis-brier/LouisBrierMainFloor.vue'
import {
  ActionNames as SiteStatsActionNames,
  GetterNames as SiteStatsGetterNames,
} from '@/store/modules/site-stats/keys'
import { PatientMap } from '@/utils/patient-maps'
import SearchForm from '@/components/sub-components/SearchForm.vue'
import {
  ActionNames as PatientWithEventActionNames,
  GetterNames as PatientWithEventGetterNames,
} from '@/store/modules/patient-with-events/keys'
import { GetterNames as PatientNoteGetterNames } from '@/store/modules/patient-note/keys'
import PatientUpdates from '@/components/care-team-dashboard/PatientUpdates.vue'
import NeedsAttention from '@/components/care-team-dashboard/NeedsAttention.vue'
import DemoMap from '@/components/map/static-maps/demo/DemoMap.vue'

/*
Display options are currently hard-coded for Louis Brier Main Floor only
In future we could include sub-map info in siteStats and use this
to render sub-map components as needed.
*/

const enum MapDisplayOptionNames {
  WestWingOnly = 'West Wing',
  FullMap = 'Full Map',
}

const enum MapDisplayOptionIndexes {
  WestWingOnly = 0,
  FullMap = 1,
}

const MapDisplayOptions = [
  {
    name: MapDisplayOptionNames.WestWingOnly,
    index: MapDisplayOptionIndexes.WestWingOnly,
    isSubMap: true,
    component: 'west-wing-enlarged',
  },
  {
    name: MapDisplayOptionNames.FullMap,
    index: MapDisplayOptionIndexes.FullMap,
    isSubmap: false,
    component: null,
  },
]

export default Vue.extend({
  components: {
    SearchForm,
    LouisBrierMainFloor,
    DemoMap,
    NeedsAttention,
    PatientUpdates,
  },
  props: {
    patients: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      loaded: false,
      refreshTime: 30 * 1000,
      timeout: null,
      inactivityTimeout: null,
      isStoppedRefreshing: false,
      patientNoun: PATIENT_NOUN,
      time: null,
      // availableMaps: ALL_MAPS, // todo load these from somewhere...
      selectedMap: null,
      searchQuery: '',
      sharedRooms: {},
      patientsByRoomNumber: {},
      chosenMapDisplayIndex: MapDisplayOptionIndexes.FullMap,
    }
  },
  computed: {
    ...mapGetters(ModuleNames.patient, [PatientGetterNames.activePatients]),
    ...mapGetters(ModuleNames.siteStats, {
      // for map
      siteStatses: SiteStatsGetterNames.siteStatses,
    }),
    ...mapGetters({
      patientRecentNotesGroupByPatientId: `${ModuleNames.patientNotes}/${PatientNoteGetterNames.patientRecentNotesGroupByPatientId}`,
      patientWithUrgentEvents: `${ModuleNames.patientWithEvents}/${PatientWithEventGetterNames.patientWithUrgentEvents}`,
      patientWithNewChangesEvents: `${ModuleNames.patientWithEvents}/${PatientWithEventGetterNames.patientWithNewChangesEvents}`,
    }),
    ...mapState(ModuleNames.patient, [PatientGetterNames.activePatients]),
    ...mapState(ModuleNames.patientWithEvents, ['patientWithEvents']),
    progressClass() {
      return this.loading ? 'loading-active' : 'loading-inactive'
    },
    getMaps() {
      let maps: PatientMap[] = []
      console.log(this.siteStatses)
      this.siteStatses.forEach(siteStats => {
        siteStats.patientMaps.forEach(map => {
          maps.push(map)
        })
      })
      return maps
    },
    isLouisBrierMainFloor() {
      if (this.selectedMap) {
        return this.selectedMap.mapId === 'louis-brier-main-floor'
      }
      return false
    },
    mapDisplayOptions() {
      //only relevant to Louis Brier Main Floor at the moment
      //look at adding this to siteStats in future
      return MapDisplayOptions.map(option => ({
        ...option,
        isActive: this.chosenMapDisplayIndex === option.index,
        isDisabled: option.isSubMap ? this.mapHasUnaddressedLiveAlerts : false,
      }))
    },
    chosenMapDisplayOption() {
      //only relevant to Louis Brier Main Floor at the moment
      return this.mapDisplayOptions[this.chosenMapDisplayIndex]
    },
    mapHasUnaddressedLiveAlerts() {
      return !this.patients.every(patient => {
        if (!patient.liveEvents || patient.liveEvents.length === 0) {
          return true
        }
        return patient.liveEvents.every(event => {
          return hasUnaddressedLiveAlert(patient.id, event) ? false : true
        })
      })
    },
  },
  watch: {
    mapHasUnaddressedLiveEvents: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.chosenMapDisplayIndex = MapDisplayOptionIndexes.FullMap
        }
      },
    },
    searchQuery: {
      handler(newVal, oldVal) {
        //map view should only change to fullmap when user
        //enters new characters (not when clearing or backspacing)
        if (!newVal) {
          return
        }
        if (newVal.length < oldVal.length) {
          return
        }
        return (this.chosenMapDisplayIndex = MapDisplayOptionIndexes.FullMap)
      },
    },
  },
  async mounted() {
    this.time = this.formatTime()
    this.initInactivityTimeout()
    await this.fetchData()
    this.resumeRefreshing()
  },
  beforeDestroy(): void {
    this.stopRefreshing()
  },
  methods: {
    ...mapActions(ModuleNames.patient, [PatientActionNames.getPatients]),
    ...mapActions(ModuleNames.patientWithEvents, [PatientWithEventActionNames.getPatientWithEvents]),
    ...mapActions(ModuleNames.siteStats, [SiteStatsActionNames.getSiteStatses]),
    async fetchData() {
      this.loading = true
      console.log('fetchData()!')
      try {
        await this[SiteStatsActionNames.getSiteStatses]()
        await this[PatientActionNames.getPatients]()
        await this[PatientWithEventActionNames.getPatientWithEvents]()
        this.selectedMap = this.selectedMaps || this.getMaps[0]
        await this.loadSharedRooms()
        await this.loadPatientsByRoomNumber()
        this.loaded = true
      } catch (e) {
        console.warn(e)
      }
      this.time = this.formatTime()
      this.loading = false
    },
    initInactivityTimeout() {
      window.onload = this.resetInactivityTimeout
      document.onmousemove = this.resetInactivityTimeout
      document.onkeydown = this.resetInactivityTimeout
      this.resetInactivityTimeout()
    },
    resetInactivityTimeout() {
      clearTimeout(this.inactivityTimeout)
      this.inactivityTimeout = setTimeout(location.reload, 30 * 60 * 1000) // 30 min
    },
    searchTextChanged() {
      this.loadSharedRooms()
      this.loadPatientsByRoomNumber()
    },
    stopRefreshing() {
      this.isStoppedRefreshing = true
    },
    resumeRefreshing() {
      this.isStoppedRefreshing = false
      this.startRefreshing()
    },
    startRefreshing() {
      if (this.isStoppedRefreshing) return
      clearTimeout(this.timeout)
      this.timeout = setTimeout(async () => {
        try {
          await this.fetchData()
        } catch (e) {
          console.log('error', e)
        }
        this.startRefreshing()
      }, this.refreshTime)
    },
    formatTime() {
      let tz = this.patients && this.patients[0] && this.patients[0].timezone
      return toReadableTimeFromTimestamp(currentTimestamp(), 'h:mm a', tz)
    },

    async loadPatientsByRoomNumber() {
      let patientsByRoomNumber = {}
      this.patients.forEach(patient => {
        if (!patient) return

        this.$set(patient, 'searched', this.searchQuery == patient.roomNumber)

        if (patient.searched) {
          console.log('Searched ' + this.searchQuery + '=' + patient.roomNumber + ' => ' + patient.searched)
        }
        let ownRoomNumber = patient.roomNumber
        if (!ownRoomNumber) return

        patientsByRoomNumber[ownRoomNumber] = patient
      })
      this.patientsByRoomNumber = patientsByRoomNumber
    },
    loadSharedRooms: async function() {
      let sharedRooms = {}
      if (!this.selectedMap || !this.selectedMap.sharedRooms) {
        return
      }

      this.selectedMap.sharedRooms.forEach(room => {
        room.currentResidents &&
          room.currentResidents.forEach(resident => {
            this.$set(resident, 'searched', this.searchQuery == resident.roomNumber)
          })

        room.currentResidents = []
        sharedRooms[room.sharedRoomId] = room
      })
      this.patients.forEach(patient => {
        if (!patient) return
        if (!isInAnyRoom(patient)) return // this checks for out of room timing
        let sharedRoomId = patient.lastConnectionSharedRoomId
        if (!sharedRoomId) return
        if (!patient.roomNumber) return // don't add patients that shouldn't be on the map

        this.$set(patient, 'searched', this.searchQuery == patient.roomNumber)
        // patient.searched = this.searchQuery == patient.roomNumber
        if (sharedRooms[sharedRoomId]) {
          sharedRooms[sharedRoomId].currentResidents.push(patient)
        }
      })

      this.sharedRooms = sharedRooms
    },
  },
})
